import { useState } from 'react';
import { ErrorMasterKeyModal } from './widgets';
import { Footer } from '@widgets/footer';
import { Button, CodeInput, Input } from '@shared/widgets';
import bgImg from '@assets/images/auth/bg-02.png';

export const RecoveryCodePage = () => {
  const [newPassword, setNewPassword] = useState('');
  const [retypePassword, setRetypePassword] = useState('');
  const [code, setCode] = useState('');
  const [newPasswordError, setNewPasswordError] = useState('');
  const [retypePasswordError, setRetypePasswordError] = useState('');
  const [codeError, setCodeError] = useState('');
  const [, setErrorValidate] = useState(false);
  const [loader, setLoader] = useState(false);
  const [errorCount, setErrorCount] = useState(0);

  const handleInput = (name: string, value: string) => {
    if (name === 'newPassword') setNewPassword(value);
    if (name === 'retypePassword') setRetypePassword(value);
    if (name === 'code') setCode(value);
    validateField(name, value);
  };

  const validateField = (fieldName: string, value: string) => {
    let error = false;
    let text = '';

    switch (fieldName) {
      case 'newPassword':
        if (value.length < 6) {
          text = 'INCORRECT NEW PASSWORD';
          error = true;
        }
        setNewPasswordError(text);
        break;
      case 'retypePassword':
        if (value.length < 6) {
          text = 'INCORRECT RETYPE PASSWORD';
          error = true;
        }
        setRetypePasswordError(text);
        break;
      case 'code':
        if (value.length != 6) {
          text = 'INCORRECT CODE';
          error = true;
        }
        setCodeError(text);
        break;
    }

    setErrorValidate(error);

    return !error;
  };

  const sendForm = () => {
    if (validateField('newPassword', newPassword) && validateField('retypePassword', retypePassword) && validateField('code', code)) {
      setLoader(true);
    }
  };

  return (
    <>
      <div className='mx-auto flex h-[702px] max-w-[1440px] overflow-hidden max-md:relative max-md:z-[1] max-md:h-auto max-md:w-full max-md:flex-col-reverse'>
        <div className='relative z-[99] w-[140px] max-md:hidden' />
        <div
          className='relative z-[99] h-[702px] w-full bg-right bg-no-repeat pl-[150px] text-left max-md:h-auto max-md:!bg-none max-md:pt-0 max-md:pl-0'
          style={{ backgroundImage: `url(${bgImg})` }}
        >
          <div className='w-[590px] max-md:relative max-md:w-full max-md:px-4 max-md:pt-5 max-md:pb-12'>
            <h2 className='mt-[103px] font-[Prata] text-[56px] text-[#272727] max-md:mt-0 max-md:text-center max-md:text-[28px]'>
              Password Recovery
            </h2>
            <p className='mt-7.5 w-[517px] text-lg font-medium text-[#000000]'>
              Master Key has generated a one-time confirmation code, please insert it below to complete the password recovery process.
            </p>

            <div className='mt-2 flex items-center gap-2 max-md:mt-4 max-md:block'>
              <Input
                inputClassName='w-[292px]'
                label='New Password'
                name='newPassword'
                value={newPassword}
                onChange={(value) => handleInput('newPassword', value)}
              />
              {newPasswordError && (
                <div className='mt-8 flex items-baseline gap-1 max-md:hidden'>
                  <div className='h-[13px] w-[12px] rounded-full bg-[#d0021b] text-center text-xs font-bold text-[#fff]'>!</div>
                  <div className='text-xs font-bold text-[#d0021b] uppercase'>{newPasswordError}</div>
                </div>
              )}
            </div>
            <div className='mt-2 flex items-center gap-2 max-md:mt-4 max-md:block'>
              <Input
                inputClassName='w-[292px]'
                label='Retype New Password'
                name='retypePassword'
                value={retypePassword}
                onChange={(value) => handleInput('retypePassword', value)}
              />
              {retypePasswordError && (
                <div className='mt-8 flex items-baseline gap-1 max-md:hidden'>
                  <div className='h-[13px] w-[12px] rounded-full bg-[#d0021b] text-center text-xs font-bold text-[#fff]'>!</div>
                  <div className='text-xs font-bold text-[#d0021b] uppercase'>{retypePasswordError}</div>
                </div>
              )}
            </div>
            <div className='mt-4 w-[294px] text-center max-md:w-full'>
              <CodeInput isFocus onComplete={setCode} />
              {codeError && (
                <div className='mt-8 flex items-baseline gap-1 max-md:hidden'>
                  <div className='h-[13px] w-[12px] rounded-full bg-[#d0021b] text-center text-xs font-bold text-[#fff]'>!</div>
                  <div className='text-xs font-bold text-[#d0021b] uppercase'>{codeError}</div>
                </div>
              )}
              <div className='mt-4 cursor-pointer text-xs font-medium text-[#272727] uppercase max-md:normal-case'>
                Problems with my Master Key code
              </div>
            </div>
            <Button className='mt-5 w-[292px] max-md:mt-8 max-md:w-full' isLoading={loader} onClick={sendForm}>
              Submit
            </Button>
          </div>
        </div>
      </div>
      <Footer />
      {/* TODO: NOT WORKING BEFORE */}
      <ErrorMasterKeyModal isOpen={errorCount >= 3} onClose={() => setErrorCount(0)} />
    </>
  );
};
